//components
import React from "react";
import { connect } from "react-redux";
import { CareCircleAction } from "./CareCircleAction";
import SendInvite from "./SendInvite/SendInvite";
import ManageList from "./ManageList/ManageList";
import { Modal } from "../CustomModal/Modal";
import CustomSpinner from "../Spinner/Spinner";
import DashBordAction from "../Dashboard/DashboardAction";
import { PATHS } from "./../../Constants";
import PendingInvites from "./PendingInvites/PendingInvites";

//styling
import "./CareCircle.scss";
import "../../Resources/Styles/fonts.scss";
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";

//reources
import { Strings } from "../../Resources/Strings/i18n";
import CommonUtils from "../../Utils/CommonUtils";
import selectRoleIcon from "../../Resources/Images/ic_help.png";
import radioButton from "../../Resources/Images/ic_radio_button_outline.png";
import selectedRadioButton from "../../Resources/Images/ic_radio_button_filled.png";
import popupClose from "../../Resources/Images/ic_popup_close.png";

//constants
import FLAG_SELECTOR_OPTION_LIST from "../../Countries";
import { OperationStatus, APIResponse } from "../../Communication/Constants";
import { parsePhoneNumberFromString } from "libphonenumber-js";

//components
import ReactCustomFlagSelect from "react-custom-flag-select";
import { PhoneNumberUtil } from "google-libphonenumber";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Divider from "../Divider/Divider";

class CareCircle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      first_name_error: false,
      emailId: "",
      emailIdError: false,
      last_name: "",
      mobileNumberValue: "",
      mobileNumberError: false,
      mobileNumberValid: false,
      callingCode: "+1",
      isValid: false,
      role: "",
      relation: "",
      showModal: false,
      setSendInvitationModal: false,
      selectedTabIndex: "0",
      roleNotSelectedError: false,
      errorMessage: "",
      showErrorModal: false,
      showSuccessModal: false,
      hintAns: false,
    };

    this.CareCircleAction = new CareCircleAction();
    this.DashBordAction = new DashBordAction();
  }

  componentDidMount() {
    localStorage.removeItem("selectedAlertId");
    localStorage.removeItem("myState");
    if (
      this.props.inviteTokenInfo &&
      this.props.inviteTokenInfo.isInvitedUser
    ) {
      this.props.history.push("/home");
    }
    if (!this.props.userInfo || !this.props.userInfo.id) {
      this.setState({
        showErrorModal: true,
        errorMessage: Strings("ERROR_INVALID_AUTH_GRANT"),
        //"Session expired or error occurred, please login again!",
      });
    } else {
      // if (!this.props.userInfo.mobile) {
      //   this.setState({
      //     showErrorModal: true,
      //     errorMessage: Strings("PhoneNumberRequiredMessage"),
      //   });
      // } else {
      //to get everytime updated data
      this.DashBordAction.getList(
        {
          userid: this.props.userInfo.id, //this.props.currentUserInfo.accessToken,
        },
        (listResponse) => {
          //this.setState({userList})
        }
      );
      // }
    }
  }

  componentDidUpdate(prevprops) {
    if (
      this.state.setSendInvitationModal !== prevprops.setSendInvitationModal
    ) {
      if (this.state.setSendInvitationModal) {
        document.querySelector("body").style.overflow = "hidden";
      } else {
        document.querySelector("body").style.overflow = "auto";
      }
    }
  }

  componentWillUnmount() {
    if (this.state.setSendInvitationModal === false) {
      document.querySelector("body").style.overflow = "auto";
    }
  }

  sendInvitation = (modifiedNumber) => {
    this.setState({ showModal: true });
    let requestObj = {
      first_name: this.state.first_name,
      last_name: this.state.last_name ? this.state.last_name : null,
      mobile: modifiedNumber && modifiedNumber,
      calling_code: this.state.callingCode ? this.state.callingCode : null,
      relation: this.state.relation ? this.state.relation : null,
      email: !this.state.emailIdError ? this.state.emailId : null,
      role: this.state.role,
    };
    if (!this.state.emailId) {
      delete requestObj.email;
    } else {
      if (this.state.mobileNumberValue === "" || this.state.mobileNumberError) {
        delete requestObj.mobile;
        delete requestObj.calling_code;
      }
    }
    if (!this.state.last_name && !this.state.relation) {
      delete requestObj.relation;
      delete requestObj.last_name;
    } else {
      if (!this.state.last_name) {
        delete requestObj.last_name;
      } else if (!this.state.relation) {
        delete requestObj.relation;
      }
    }
    if (
      this.state.mobileNumberValue &&
      !this.state.mobileNumberError &&
      this.state.emailId &&
      !this.state.emailIdError
    ) {
      delete requestObj.email;
    }
    this.CareCircleAction.careCircleAction(
      [requestObj],
      // { role: this.state.role },
      (actionCallback) => {
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.setState({ showModal: false, showSuccessModal: true });
          this.DashBordAction.getList(
            {
              userid: this.props.userInfo.id, //this.props.currentUserInfo.accessToken,
            },
            (listResponse) => {
              //this.setState({userList})
            }
          );
        } else {
          if (
            actionCallback.error.errorCode === APIResponse.OPERATION_NOT_ALLOWED
          ) {
            this.setState({
              errorMessage: actionCallback.error.errorMessage,
              showErrorModal: true,
              showSuccessModal: false,
              showModal: false,
            });
          } else if (
            actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE
          ) {
            this.setState({
              showErrorModal: true,
              errorMessage: actionCallback.error.errorMessage,
              showSuccessModal: false,
              showModal: false,
            });
          } else if (
            actionCallback.error.errorCode ===
            APIResponse.MOBILE_NUMBER_ALREADY_CONNECTED_TO_SENIOR
          ) {
            this.setState({
              showErrorModal: true,
              errorMessage: actionCallback.error.errorMessage,
              showSuccessModal: false,
              showModal: false,
            });
          } else {
            this.setState({
              showErrorModal: true,
              errorMessage: actionCallback.error.errorMessage,
              showSuccessModal: false,
              showModal: false,
            });
          }
        }
      }
    );
  };

  showSendInvitationModal = () => {
    this.setState({ setSendInvitationModal: true });
  };

  isMobileWithCallingCodeValid(mobileNumberWithCallingCode) {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const parsedNumberWithCode = phoneUtil.parse(mobileNumberWithCallingCode);
      return phoneUtil.isValidNumber(parsedNumberWithCode);
    } catch (exception) {
      return false;
    }
  }

  onMobileChangeHandler = (mobileValue) => {
    //this.setState({ emailId: "", emailIdError: false });
    let mobileNumberText = String(mobileValue);
    let mobileError = false;
    if (mobileNumberText === "") {
      this.setState({
        mobileNumberValue: mobileNumberText,
        mobileNumberError: false,
        isValid: false,
      });
      mobileError = true;
    } else if (CommonUtils.isValidNumber(mobileNumberText)) {
      const mobileNumberWithCallingCode =
        this.state.callingCode + mobileNumberText;

      if (this.isMobileWithCallingCodeValid(mobileNumberWithCallingCode)) {
        this.setState({
          mobileNumberValue: mobileNumberText,
          mobileNumberError: false,
          isValid: true,
        });
        mobileError = false;
      } else {
        this.setState({
          mobileNumberValue: mobileNumberText,
          mobileNumberError: true,
          isValid: false,
        });
        mobileError = true;
      }
    } else {
      mobileError = false;
    }
    return mobileError;
  };

  onSubmitHandler = (event) => {
    event.preventDefault();
    let mobileValue = this.onMobileChangeHandler(this.state.mobileNumberValue);

    let { first_name_error, emailIdError, mobileNumberValue } = this.state;

    //check added if user enter 0 in  mobile number starting
    let number = parsePhoneNumberFromString(
      this.state.callingCode + mobileNumberValue
    );
    let modifiedNumber = "";
    if (!number) {
      this.setState({ mobileNumberError: true });
      this.setState({mobileNumberValue:""})
    } else {
      modifiedNumber = number.number.substring(this.state.callingCode.length);
      mobileNumberValue = modifiedNumber;
      this.setState({mobileNumberValue:modifiedNumber})
    }
    if (this.state.emailId && !CommonUtils.isEmailValid(this.state.emailId)) {
      emailIdError = true;
      if (!mobileNumberValue) {
        mobileValue = false;
      }
    } else {
      emailIdError = false;
      if (!mobileNumberValue) {
        mobileValue = false;
      }
    }

    if (
      (mobileNumberValue && !mobileValue) ||
      (this.state.emailId && !emailIdError && !mobileValue)
    ) {
      if (
        this.state.callingCode + mobileNumberValue ===
          this.props.userInfo.mobile ||
        (!mobileNumberValue &&
          this.state.emailId === this.props.userInfo.email)
      ) {
        this.setState({
          showErrorModal: true,
          errorMessage:
            (!mobileNumberValue && this.state.emailId) ===
            this.props.userInfo.email
              ? Strings("SelfEmailAddedErrorMsg")
              : Strings("SelfNumberAddedErrorMsg"),
          showSuccessModal: false,
          showModal: false,
          mobileNumberValue: "",
        });
      } else {
        this.setState({
          setSendInvitationModal: false,
          roleNotSelectedError: false,
          mobileNumberError: false,
          first_name: "",
          last_name: "",
          role: "",
          relation: "",
          mobileNumberValue: "",
          selectedTabIndex: "0",
          callingCode: "+1",
          emailId: "",
          emailIdError: false,
        });

        //Api call
        this.sendInvitation(modifiedNumber);
        
      }
    } else {
      this.setState({
        first_name_error,
        emailIdError,
        mobileNumberError: mobileValue,
      });
    }
  };

  //accept/decline
  acceptDeclineHandler = (inviteParam) => {
    this.setState({ showModal: true });
    let { invitation_id = "", status = "" } = inviteParam || {};

    this.CareCircleAction.acceptDeclineAction(
      {
        invites: [
          {
            invite_id: invitation_id,
            status: status,
          },
        ],
      },
      { userid: this.props.userInfo.id },
      (actionCallback) => {
        if (actionCallback.status === OperationStatus.SUCCESS) {
          this.DashBordAction.getList(
            {
              userid: this.props.userInfo.id, //this.props.currentUserInfo.accessToken,
            },
            (listResponse) => {
              this.setState({ showModal: false });
            }
          );
        } else {
          if (
            actionCallback.error.errorCode === APIResponse.OPERATION_NOT_ALLOWED
          ) {
            this.setState({
              errorMessage: actionCallback.error.errorMessage,
              showErrorModal: true,
              showModal: false,
            });
          } else if (
            actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE
          ) {
            this.setState({
              showErrorModal: true,
              errorMessage: actionCallback.error.errorMessage,
              showModal: false,
            });
          }
        }
      }
    );
  };
  //on focus
  onFirstNameFocus = () => {
    this.setState({ first_name_error: false });
  };
  onMobileFocus = () => {
    this.setState({
      mobileNumberError: false,
    });
  };
  onEmailFocus = () => {
    this.setState({
      emailIdError: false,
    });
  };

  onNameChangeHandler = (event) => {
    let name = event.target.value;

    if (!name.match(/^[a-zA-Z]+$/)) {
      this.setState({ isValid: false, first_name: "", isValidName: false });
    } else {
      this.setState({ first_name: name, isValid: true, isValidName: true });
    }
  };

  findCountry = (CountryArray, CountryData) => {
    const matchedCountries = [];
    CountryArray.forEach((CountryInfo) => {
      let match = false;
      Object.keys(CountryData).forEach((InfoItem) => {
        if (CountryData[InfoItem] === CountryInfo[InfoItem]) {
          match = true;
        }
      });
      if (match) {
        matchedCountries.push(CountryInfo);
      }
    });
    return matchedCountries;
  };

  render() {
    const callingCode = this.state.callingCode;
    const selectedCountry = this.findCountry(FLAG_SELECTOR_OPTION_LIST, {
      id: callingCode,
    })[0];

    return (
      <div className="CareCircle">
        <CustomSpinner showModal={this.state.showModal} />
        {this.state.showErrorModal ? (
          <Modal
            show={this.state.showErrorModal}
            handleClose={this.hideModal}
            parent={"exitsession"}
          >
            {
              <div>
                <div className="errorOtp">
                  <div className="errorModal">
                    <div className="modalTitle">
                      {/* {!this.props.userInfo.mobile? (
                        <p id="errorTitle">
                          <span id="errorText">
                            {Strings("PhoneNumberRequired")}
                          </span>
                        </p>
                      ) : ( */}
                      <p id="errorTitle">
                        <span id="errorText">{Strings("Error")}</span>
                        {Strings("ErrorOccurred")}
                      </p>
                      {/* )} */}
                    </div>
                    <div className="errorContainer">
                      <div className="errorContent">
                        <p>{this.state.errorMessage}</p>
                      </div>
                    </div>
                    <Button
                      className="errorBtn"
                      onClick={() => {
                        this.setState(
                          {
                            showErrorModal: false,
                          },
                          () => {
                            !this.props.userInfo.id
                              ? this.props.history.push(PATHS.LOGIN)
                              : this.props.history.push();
                            // : this.props.userInfo.mobile
                            // ? this.props.history.push()
                            // : this.props.history.push(PATHS.HOME);
                          }
                        );
                      }}
                    >
                      {this.state.errorMessage ===
                      String("ERROR_INVALID_AUTH_GRANT")
                        ? Strings("CloseAndLogin")
                        : Strings("Close")}
                    </Button>
                  </div>
                </div>
              </div>
            }
          </Modal>
        ) : null}

        <SendInvite showSendInvitationModal={this.showSendInvitationModal} />
        {this.state.setSendInvitationModal ? (
          <div className="getUserInfoModal">
            <div className="showBackdrop"></div>
            <div className="userInfoModal">
              <form onSubmit={this.onSubmitHandler}>
                <img
                  src={popupClose}
                  alt="popup-close"
                  className="popup-close"
                  onClick={() =>
                    this.setState({
                      setSendInvitationModal: false,
                      first_name: "",
                      first_name_error: false,
                      last_name: "",
                      mobileNumberValue: "",
                      roleNotSelectedError: false,
                      mobileNumberError: false,
                      role: "",
                      relation: "",
                      callingCode: "+1",
                      selectedTabIndex: "0",
                      emailId: "",
                      emailIdError: false,
                    })
                  }
                />
                <p className="userInfoModal-heading">
                  {Strings("InviteUsingMobileNumber") +
                    " " +
                    Strings("or") +
                    " " +
                    Strings("EmailPlaceHolder")}
                </p>
                <div className="userName">
                  <div className="firstName">
                    <TextField
                      required
                      type="text"
                      autoComplete="off"
                      id="standard-basic"
                      label={
                        this.state.first_name_error
                          ? Strings("FirstNameError")
                          : Strings("FirstName")
                      }
                      name={Strings("FirstName")}
                      value={this.state.first_name}
                      error={this.state.first_name_error}
                      onChange={this.onNameChangeHandler}
                      onFocus={this.onFirstNameFocus}
                    />
                  </div>
                  <div className="lastname">
                    <TextField
                      id="standard-basic"
                      autoComplete={"off"}
                      label={Strings("LastName") + Strings("Optional")}
                      value={this.state.last_name}
                      onChange={(event) => {
                        if (event.target.value.match(/^[a-zA-Z]+$/)) {
                          this.setState({ last_name: event.target.value });
                        } else {
                          this.setState({ last_name: "" });
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="RelationShipBlock">
                  {
                    <FormControl className="formControl">
                      <InputLabel htmlFor="age-native-simple">
                        {Strings("Relationship")}
                      </InputLabel>
                      <Select
                        value={this.state.relation}
                        onChange={(event) =>
                          this.setState({ relation: event.target.value })
                        }
                        inputProps={{
                          name: "age",
                          id: "age-native-simple",
                        }}
                      >
                        <MenuItem value="Mother">Mother</MenuItem>
                        <MenuItem value="Father">Father</MenuItem>
                        <MenuItem value="Brother">Brother</MenuItem>
                        <MenuItem value="Sister">Sister</MenuItem>
                        <MenuItem value="Cousin">Cousin</MenuItem>
                        <MenuItem value="Friend">Friend</MenuItem>
                        <MenuItem value="Son">Son</MenuItem>
                        <MenuItem value="Daughter">Daughter</MenuItem>
                        <MenuItem value="Wife">Wife</MenuItem>
                        <MenuItem value="Husband">Husband</MenuItem>
                        <MenuItem value="Spouse">Spouse</MenuItem>
                        <MenuItem value="Family">Family</MenuItem>
                        <MenuItem value="Loved One">Loved One</MenuItem>
                        <MenuItem value="Caregiver">Caregiver</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  }
                </div>
                <div className="mobileNumberSection">
                  <div className="callingCodePicker">
                    <label className={"callingCodeLabel"}>
                      {Strings("Country")}
                    </label>
                    <ReactCustomFlagSelect
                      tabIndex={"1"}
                      id={this.state.callingCode}
                      name={"callingCode"}
                      value={selectedCountry.id}
                      showSearch={true}
                      showArrow={true}
                      animate={true}
                      optionList={FLAG_SELECTOR_OPTION_LIST}
                      customStyleContainer={{
                        border: "none",
                        fontSize: "12px",
                      }}
                      customStyleSelect={{
                        width: "100%",
                        height: "25px",
                        padding: "0px 20px",
                      }}
                      customStyleOptionListContainer={{
                        margin: "0px",
                        maxHeight: "155px",
                        overflow: "auto",
                        width: "130px",
                      }}
                      onChange={(CallingCode) => {
                        this.setState({
                          callingCode: CallingCode,
                          mobileNumberValue: "",
                        });
                      }}
                    />
                  </div>
                  <div className="mobileNumberBlock">
                    <div>
                      <TextField
                        required={this.state.emailId ? false : true}
                        id="standard-basic"
                        autoComplete={"off"}
                        className="mobileNumberField"
                        onChange={(event) => {
                          let regex = /^[0-9\b]+$/; // allow only numbers [0-9]
                          if (regex.test(event.target.value)) {
                            if (event.target.value.length < 16) {
                              this.setState({
                                mobileNumberValue: event.target.value,
                              });
                            }
                          } else {
                            this.setState({
                              mobileNumberValue: "",
                            });
                          }
                        }}
                        value={this.state.mobileNumberValue}
                        error={this.state.mobileNumberError}
                        label="Mobile Number"
                        onFocus={this.onMobileFocus}
                      />
                    </div>
                  </div>
                </div>

                {/* OR */}
                <Divider text={Strings("OR")} />
                <div className="emailSection">
                  <TextField
                    required={
                      this.state.mobileNumberValue &&
                      !this.state.mobileNumberError
                        ? false
                        : true
                    }
                    autoComplete="off"
                    type="email"
                    id="standard-basic"
                    label={Strings("EmailPlaceHolder")}
                    name={Strings("EmailPlaceHolder")}
                    value={this.state.emailId}
                    error={this.state.emailIdError}
                    onChange={(event) => {
                      this.setState({
                        emailId: event.target.value,
                        // mobileNumberValue: "",
                        // mobileNumberError: false,
                      });
                    }}
                    onFocus={this.onEmailFocus}
                  />
                </div>

                <div className="SelectRoleBlock">
                  <div className="SelectRoleBlock-heading">
                    <span className="Heading">{Strings("SelectRole")}</span>
                    <span>
                      <img
                        src={selectRoleIcon}
                        alt="select role"
                        onClick={() => {
                          this.setState({ hintAns: true });
                          setTimeout(() => {
                            this.setState({ hintAns: false });
                          }, 4000);
                        }}
                      />
                    </span>
                  </div>
                  {this.state.roleNotSelectedError ? (
                    <small className="roleNotSelectedError">
                      please select a role
                    </small>
                  ) : null}

                  <div className="SelectRoleBlock-content">
                    <div
                      className="selectRole-left"
                      onClick={() =>
                        this.setState({
                          selectedTabIndex: "1",
                          role: "1",
                          roleNotSelectedError: false,
                        })
                      }
                    >
                      <img
                        src={
                          this.state.selectedTabIndex === "1"
                            ? selectedRadioButton
                            : radioButton
                        }
                        alt="LovedOneInfo"
                      />
                      <label>{Strings("Senior")}</label>
                      <div>{Strings("LovedOneInfo")}</div>
                    </div>
                    <div
                      className="selectRole-right"
                      onClick={() =>
                        this.setState({
                          selectedTabIndex: "2",
                          role: "2",
                          roleNotSelectedError: false,
                        })
                      }
                    >
                      <img
                        src={
                          this.state.selectedTabIndex === "2"
                            ? selectedRadioButton
                            : radioButton
                        }
                        alt="CaregiverInfo"
                      />
                      <label>{Strings("CareGiver")}</label>
                      <div>{Strings("CaregiverInfo")}</div>
                    </div>
                  </div>
                </div>

                {this.state.selectedTabIndex === "1" && (
                  <Button className="sendInvitationBtn" type="submit">
                    {Strings("CaregiverBtnText")}
                  </Button>
                )}
                {this.state.selectedTabIndex === "2" && (
                  <Button className="sendInvitationBtn" type="submit">
                    {Strings("GiveAccess")}
                  </Button>
                )}

                <Snackbar
                  open={this.state.hintAns}
                  autoHideDuration={1000}
                  onClose={() => {}}
                  className="hintAnswer"
                >
                  <MuiAlert onClose={() => {}} severity="success">
                    {Strings("RoleInformationToast")}
                  </MuiAlert>
                </Snackbar>
              </form>
            </div>
          </div>
        ) : null}

        {this.state.showSuccessModal ? (
          <Modal
            show={this.state.showSuccessModal}
            handleClose={this.hideModal}
            parent={"exitsession"}
          >
            {
              <div>
                <div className="successOtp">
                  <div className="successModal">
                    <div className="modalTitle">
                      <p id="successTitle">
                        <span id="successText">{Strings("Success!")}</span>
                      </p>
                    </div>
                    <div className="successContainer">
                      <div className="successContent">
                        <p>{Strings("InviteSentSuccessfully")}</p>
                      </div>
                    </div>
                    <Button
                      className="successBtn"
                      onClick={() => {
                        this.setState({
                          showSuccessModal: false,
                        });
                      }}
                    >
                      {Strings("Ok")}
                    </Button>
                  </div>
                </div>
              </div>
            }
          </Modal>
        ) : null}

        <PendingInvites
          userList={this.props.userList}
          inviteHandler={this.acceptDeclineHandler}
        />

        <ManageList userList={this.props.userList} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    data: state.CareCircle.data,
    error: state.CareCircle.error,
    invitedUserInfo: state.Dashboard.invitedUserInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
};

export default connect(mapStateToProps, null)(CareCircle);
